import type { SVGProps } from "react";

export default function AffiliatesIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 393.18 393.18"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<g>
				<g>
					{/* Black parts - use currentColor */}
					<path fill="currentColor" d="M79.59,68.59c4.79,6.77-4.25,15.82-11,11-15.05,1.01-45.07,1.73-59.52.02-4.56-.54-8.09-3.76-8.5-8.5,1.4-19.33-1.79-41.03-.02-60.06C1.25,3.58,3.57,1.25,11.05.55c19.03-1.78,40.73,1.42,60.06.02,4.74.41,7.96,3.94,8.5,8.5,1.71,14.45.98,44.47-.02,59.52ZM62.59,17.59H17.59v45h45V17.59Z" />
					<path fill="currentColor" d="M324.59,79.59c-6.77,4.79-15.82-4.25-11-11-1.01-15.05-1.73-45.07-.02-59.52.54-4.56,3.76-8.09,8.5-8.5,19.33,1.4,41.03-1.79,60.06-.02,7.47.7,9.8,3.02,10.5,10.5,1.78,19.03-1.42,40.73-.02,60.06-.41,4.74-3.94,7.96-8.5,8.5-14.45,1.71-44.47.98-59.52-.02ZM375.59,17.59h-45v45h45V17.59Z" />
					<g>
						{/* Green parts - keep fixed color */}
						<path fill="#3fdfcf" d="M108.59,96.59c-2.92,2.55-9.45,9.08-12,12l-28-29c8.36-.56,10.44-2.65,11-11l29,28Z" />
						<path fill="#3fdfcf" d="M324.59,79.59l-28,29c-2.55-2.92-9.08-9.45-12-12l29-28c.56,8.36,2.65,10.44,11,11Z" />
					</g>
				</g>
				<g>
					{/* Black parts - use currentColor */}
					<path fill="currentColor" d="M68.59,313.59c6.77-4.79,15.82,4.25,11,11,1.01,15.05,1.73,45.07.02,59.52-.54,4.56-3.76,8.09-8.5,8.5-19.33-1.4-41.04,1.79-60.06.02-7.48-.7-9.8-3.03-10.5-10.5-1.78-19.03,1.42-40.73.02-60.06.41-4.74,3.94-7.96,8.5-8.5,14.45-1.71,44.47-.98,59.52.02ZM62.59,330.59H17.59v45h45v-45Z" />
					<path fill="currentColor" d="M324.59,313.59c15.05-1.01,45.07-1.73,59.52-.02,4.56.54,8.09,3.76,8.5,8.5-1.4,19.33,1.79,41.04.02,60.06-.7,7.48-3.03,9.8-10.5,10.5-19.03,1.78-40.73-1.42-60.06-.02-4.74-.41-7.96-3.94-8.5-8.5-1.71-14.45-.98-44.47.02-59.52-4.79-6.77,4.25-15.82,11-11ZM375.59,330.59h-45v45h45v-45Z" />
					<g>
						{/* Green parts - keep fixed color */}
						<path fill="#3fdfcf" d="M108.59,296.59l-29,28c-.56-8.35-2.64-10.44-11-11l28-29c2.55,2.92,9.08,9.45,12,12Z" />
						<path fill="#3fdfcf" d="M324.59,313.59c-8.35.56-10.44,2.64-11,11l-29-28c2.92-2.55,9.45-9.08,12-12l28,29Z" />
					</g>
				</g>
				<g>
					{/* Black parts - use currentColor */}
					<path fill="currentColor" d="M284.59,96.59c4.2-.59,12.59,7.8,12,12,43.49,49.85,43.49,126.15,0,176,.59,4.2-7.8,12.59-12,12-49.85,43.49-126.15,43.49-176,0-4.2.59-12.59-7.8-12-12-43.49-49.85-43.49-126.15,0-176-.59-4.2,7.8-12.59,12-12,49.85-43.49,126.15-43.49,176,0ZM185.39,80.89c-81.23,7.17-129.18,95.98-92.32,168.72,37.73,74.46,142.8,85.27,194.5,19.46,63.41-80.72-.06-197.2-102.18-188.18Z" />
					{/* Green parts - keep fixed color */}
					<path fill="#3fdfcf" d="M228.59,193.58c19.36,6.95,35.04,27.34,37.9,47.61,1.2,8.49,1.94,18.38-9.36,18.44-38.94-2.78-82.72,3.56-121.08,0-11.76-1.09-10.72-9.66-9.21-19.29,3.13-19.99,18.61-39.87,37.75-46.77.41-1.51-.4-1.65-.98-2.5-2.54-3.66-6.39-6.49-8.84-11.16-14.09-26.88.84-61.21,30.62-68.03,39.88-9.13,70.86,30.93,53.38,67.38l-10.17,14.31ZM189.33,127.83c-9.14,1.54-18.55,10.85-21.52,19.48-8.9,25.94,16.8,49.26,42.01,38.01,30.58-13.64,18.62-64.09-20.5-57.5ZM249.59,242.59c-6.43-30.55-31.68-40.01-60.54-38.04-22.93,1.56-41.01,14.97-45.46,38.04h106Z" />
				</g>
			</g>
		</svg>
	);
}

